import React from 'react';
import { Chip, alpha } from '@mui/material';
import {
  CheckCircle,
  Cancel,
  Schedule,
  Error,
  Info,
  HourglassEmpty,
} from '@mui/icons-material';

const statusConfig = {
  active: {
    label: 'Activo',
    color: '#10b981',
    bgColor: '#d1fae5',
    icon: CheckCircle,
  },
  inactive: {
    label: 'Inactivo',
    color: '#64748b',
    bgColor: '#f1f5f9',
    icon: Cancel,
  },
  pending: {
    label: 'Pendiente',
    color: '#f59e0b',
    bgColor: '#fef3c7',
    icon: Schedule,
  },
  processing: {
    label: 'Procesando',
    color: '#3b82f6',
    bgColor: '#dbeafe',
    icon: HourglassEmpty,
  },
  error: {
    label: 'Error',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icon: Error,
  },
  success: {
    label: 'Exitoso',
    color: '#10b981',
    bgColor: '#d1fae5',
    icon: CheckCircle,
  },
  warning: {
    label: 'Advertencia',
    color: '#f59e0b',
    bgColor: '#fef3c7',
    icon: Error,
  },
  info: {
    label: 'Info',
    color: '#06b6d4',
    bgColor: '#cffafe',
    icon: Info,
  },
  inStock: {
    label: 'En Stock',
    color: '#10b981',
    bgColor: '#d1fae5',
    icon: CheckCircle,
  },
  outOfStock: {
    label: 'Sin Stock',
    color: '#ef4444',
    bgColor: '#fee2e2',
    icon: Cancel,
  },
  admin: {
    label: 'Administrador',
    color: '#8b5cf6',
    bgColor: '#ede9fe',
    icon: null,
  },
  user: {
    label: 'Usuario',
    color: '#64748b',
    bgColor: '#f1f5f9',
    icon: null,
  },
};

const StatusBadge = ({
  status,
  label,
  showIcon = true,
  size = 'small',
  variant = 'filled',
  customColor,
  customBgColor,
  sx = {},
}) => {
  const config = statusConfig[status] || {
    label: label || status,
    color: customColor || '#64748b',
    bgColor: customBgColor || '#f1f5f9',
    icon: null,
  };

  const displayLabel = label || config.label;
  const IconComponent = config.icon;

  return (
    <Chip
      label={displayLabel}
      size={size}
      icon={showIcon && IconComponent ? (
        <IconComponent sx={{ fontSize: size === 'small' ? 14 : 18, color: `${config.color} !important` }} />
      ) : undefined}
      sx={{
        fontWeight: 600,
        fontSize: size === 'small' ? '0.7rem' : '0.8rem',
        letterSpacing: '0.02em',
        backgroundColor: variant === 'filled' ? config.bgColor : 'transparent',
        color: config.color,
        border: variant === 'outlined' ? `1.5px solid ${alpha(config.color, 0.5)}` : 'none',
        '& .MuiChip-icon': {
          marginLeft: '6px',
        },
        ...sx,
      }}
    />
  );
};

export default StatusBadge;
